import * as _dayjs2 from "dayjs";
var _dayjs = "default" in _dayjs2 ? _dayjs2.default : _dayjs2;
import { dew as _AbstractParserWithWordBoundaryDew } from "../../../../common/parsers/AbstractParserWithWordBoundary";
import { dew as _constantsDew } from "../constants";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const dayjs_1 = __importDefault(_dayjs);
  const AbstractParserWithWordBoundary_1 = _AbstractParserWithWordBoundaryDew();
  const constants_1 = _constantsDew();
  const YEAR_GROUP = 1;
  const MONTH_GROUP = 2;
  const DAY_GROUP = 3;
  class ZHHantDateParser extends AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking {
    innerPattern() {
      return new RegExp("(" + "\\d{2,4}|" + "[" + Object.keys(constants_1.NUMBER).join("") + "]{4}|" + "[" + Object.keys(constants_1.NUMBER).join("") + "]{2}" + ")?" + "(?:\\s*)" + "(?:\u5E74)?" + "(?:[\\s|,|\uFF0C]*)" + "(" + "\\d{1,2}|" + "[" + Object.keys(constants_1.NUMBER).join("") + "]{1,2}" + ")" + "(?:\\s*)" + "(?:\u6708)" + "(?:\\s*)" + "(" + "\\d{1,2}|" + "[" + Object.keys(constants_1.NUMBER).join("") + "]{1,2}" + ")?" + "(?:\\s*)" + "(?:\u65E5|\u865F)?");
    }
    innerExtract(context, match) {
      const startMoment = dayjs_1.default(context.refDate);
      const result = context.createParsingResult(match.index, match[0]);
      let month = parseInt(match[MONTH_GROUP]);
      if (isNaN(month)) month = constants_1.zhStringToNumber(match[MONTH_GROUP]);
      result.start.assign("month", month);
      if (match[DAY_GROUP]) {
        let day = parseInt(match[DAY_GROUP]);
        if (isNaN(day)) day = constants_1.zhStringToNumber(match[DAY_GROUP]);
        result.start.assign("day", day);
      } else {
        result.start.imply("day", startMoment.date());
      }
      if (match[YEAR_GROUP]) {
        let year = parseInt(match[YEAR_GROUP]);
        if (isNaN(year)) year = constants_1.zhStringToYear(match[YEAR_GROUP]);
        result.start.assign("year", year);
      } else {
        result.start.imply("year", startMoment.year());
      }
      return result;
    }
  }
  exports.default = ZHHantDateParser;
  //# sourceMappingURL=ZHHantDateParser.js.map
  return exports;
}